<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="group_1 flex-row">

           <headerMask/>
      </div>
      <span class="paragraph_1">
        从大型康养机构、康复科到康复师、健身教练个人
        <br />
        我们都提供适合他们的解决方案
        <br />
      </span>
      <span class="text_8">开运动处方找以动就够了</span>
    </div>
    <div class="box_3 flex-col">
      <div class="text-wrapper_1 flex-row"><span class="text_9">开运动处方找以动就够了</span></div>
      <div class="block_1 flex-row">
        <div class="box_4 flex-col"></div>
        <div class="box_5 flex-col"></div>
        <div class="box_6 flex-col"></div>
        <div class="box_7 flex-col"></div>
        <img
          class="thumbnail_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_4"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_10">康复逻辑流程</span>
      </div>
      <div class="block_2 flex-row">
        <div class="image-text_1 flex-col justify-between">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG94b066647492cbe38ae63ab549fce19f.png'"
          />
          <span class="text-group_1">
            患者手机端康复小程序
            <br />
            实时上传患者数据及查看运动处方
          </span>
        </div>
      </div>
      <div class="block_3 flex-row">
        <div class="image-wrapper_1 flex-col justify-between">
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGeebda8dce72639559e079958a5a6b9ca.png'"
          />
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG4cc216bc6692973b9780928779b4c2db.png'"
          />
        </div>
        <div class="text-wrapper_2 flex-col"><span class="text_11">评估设备</span></div>
        <div class="text-wrapper_3 flex-col justify-between">
          <span class="text_12">命令下达</span>
          <span class="text_13">数据上传</span>
        </div>
        <div class="box_8 flex-col">
          <div class="text-wrapper_4 flex-col"><span class="text_14">移动端APP</span></div>
          <div class="block_4 flex-row">
            <div class="image-text_2 flex-row justify-between">
              <span class="text-group_2">报告输出</span>
              <img
                class="image_5"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGe7935e1a844d2f5c63025b0e2566e19c.png'"
              />
            </div>
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG1cf001b6d4d3534c725fc72ec92eb85e.png'"
            />
            <span class="text_15">实时共享</span>
          </div>
          <div class="block_5 flex-col">
            <div class="image-wrapper_2 flex-col justify-center">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG0efb7482ff788fa82a09cbddc9a76a7c.png'"
              />
              <img
                class="image_w7"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG26270e80b5f757a7b8f922e6c68bba0f.png'"
              />
            </div>
          </div>
        </div>
        <div class="box_9 flex-col justify-between">
          <span class="text_16">处方下达</span>
          <div class="group_3 flex-row">
            <div class="image-wrapper_3 flex-col justify-center">
              <img
                class="image_8"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG26270e80b5f757a7b8f922e6c68bba0f.png'"
              />
              <img
                class="image_w8"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG0efb7482ff788fa82a09cbddc9a76a7c.png'"
              />
            </div>
            <span class="text_17">数据上传</span>
          </div>
        </div>
        <div class="text-wrapper_5 flex-col">
          <span class="paragraph_2">
            运
            <br />
            动
            <br />
            设
            <br />
            备
          </span>
        </div>
        <div class="box_10 flex-col justify-between">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG03b8713e081a14acae26e8334427a61e.png'"
          />
          <span class="text_18">功率车和四肢联动设备等</span>
        </div>
      </div>
      <div class="block_6 flex-row justify-between">
        <span class="paragraph_3">
          体适能评估和关节
          <br />
          角度评估设备
        </span>
        <div class="block_7 flex-col justify-between">
          <span class="text_19">系统及工作站</span>
          <div class="text-wrapper_6 flex-col"><span class="text_20">数据中心及系统</span></div>
        </div>
      </div>
      <div class="block_8 flex-row">
        <div class="image-text_3 flex-row justify-between">
          <span class="text-group_3">
            实
            <br />
            时
            <br />
            连
            <br />
            接
          </span>
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGe7935e1a844d2f5c63025b0e2566e19c.png'"
          />
        </div>
        <img
          class="image_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG1cf001b6d4d3534c725fc72ec92eb85e.png'"
        />
        <span class="paragraph_4">
          数
          <br />
          据
          <br />
          上
          <br />
          传
        </span>
      </div>
      <div class="block_9 flex-row">
        <div class="text-wrapper_7 flex-col"><span class="text_21">评运动中的安全设备</span></div>
      </div>
      <div class="image-wrapper_4 flex-row">
        <img
          class="image_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG54ba95184ade8c5b2949b2c942fa4ca8.png'"
        />
      </div>
      <div class="text-wrapper_8 flex-row"><span class="text_22">心率监控手环等</span></div>
    </div>
    <div class="box_11 flex-col">
      <div class="box_12 flex-row">
        <div class="group_4 flex-col"></div>
        <div class="group_5 flex-col"></div>
        <div class="group_6 flex-col"></div>
        <div class="group_7 flex-col"></div>
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_7"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_23">在医疗机构的开展情况</span>
      </div>
      <div class="box_13 flex-row">
        <div class="text-wrapper_9">
          <span class="paragraph_5">
            北京大学第一医院内分泌科病房体医融合运动指导工作站SMIS
            <br />
          </span>
          <span class="text_24">Sports&nbsp;and&nbsp;Medicine&nbsp;Integration&nbsp;Station</span>
        </div>
      </div>
      <div class="text-wrapper_10 flex-row">
        <span class="paragraph_6">
          &nbsp;&nbsp;&nbsp;&nbsp;为了解决好首都人民健康的根本需求，建立“健康北京，体医融合“的新模式，以动健康、北京体育局与北京大学第一医院内分泌科以及建立数字化运动康复中心，服务患者数千人，改善了他们的三高状况和生活质量，一类学术期刊发布论文数篇。
          <br />
        </span>
      </div>
      <div class="image-wrapper_5 flex-row justify-between">
        <img
          class="image_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGa6313f8311d580f97b37eabc55d090af.png'"
        />
        <img
          class="image_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG8b58e37444c900608344823c4f02a372.png'"
        />
        <img
          class="image_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd95c64524059e23e94ae447557aa66a4.png'"
        />
      </div>
      <div class="text-wrapper_11 flex-row"><span class="text_25">中日医院“治未病”健康管理中心运动康复站</span></div>
      <div class="text-wrapper_12 flex-row">
        <span class="paragraph_7">
          &nbsp;&nbsp;&nbsp;&nbsp;中日医院治未病门诊针对体检后存在慢病风险、亚健康人群。运用疾病风险评估，生活方式干预、危险因素控制药物治疗以及中医适宜技术等综合手段，实现早防，早诊，早治，延缓疾病的发生，提高生活质量，促进健康的目的。在2020年建立了运动康复工作站。通过特色评估，开具个性化运动处方，进行线上线下运动管理和干预。
          <br />
        </span>
      </div>
      <div class="image-wrapper_6 flex-row justify-between">
        <img
          class="image_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG01667d40293dafeea0e8d86b566a3638.png'"
        />
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG5b2235766cad75bedede9c51057b97c0.png'"
        />
        <img
          class="image_18"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG6e72b993a4ce37860dd993bfef8c48f6.png'"
        />
      </div>
      <div class="box_14 flex-row">
        <div class="box_15 flex-col"></div>
        <div class="box_16 flex-col"></div>
        <div class="box_17 flex-col"></div>
        <div class="box_18 flex-col"></div>
        <img
          class="thumbnail_8"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_9"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_10"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_26">在健康管理机构的应用案例</span>
      </div>
      <div class="text-wrapper_13 flex-row"><span class="text_27">云南省体育医院数字化运动康复中心</span></div>
      <div class="text-wrapper_14 flex-row">
        <span class="paragraph_8">
          &nbsp;&nbsp;&nbsp;&nbsp;云南省体育运动创伤专科医院属云南省体育局直属处级单位。目前在全国为第六家运动创伤专科医院。为了利用移动互联网，智能设备，远程医疗、大数据等技术，打造线上线下结合的健康运动管理服务新模式，建立了云南体育医院数字化运动康复中心SMIC。
          <br />
        </span>
      </div>
      <div class="image-wrapper_7 flex-row justify-between">
        <img
          class="image_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG602ce3cb87fed930a95d0662b7e5a84c.png'"
        />
        <img
          class="image_20"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG55db616dea4a303f25047ac7556ed5ca.png'"
        />
        <img
          class="image_21"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG17a35030df28137e0a3676bfe2343b6c.png'"
        />
      </div>
      <div class="text-wrapper_15 flex-row">
        <span class="text_28">北京顺义“妙健康”金茂怡生园加拿大健康管理中心（CWI）</span>
      </div>
      <div class="text-wrapper_16 flex-row">
        <span class="paragraph_9">
          &nbsp;&nbsp;&nbsp;&nbsp;妙健康为国内前五的健康管理企业，加拿大健康管理中心是妙健康与加拿大健康管理中心合作的国内领先的健康管理中心。建设过程融入了SMIC，并搭建了物联网科技和康复器械，研发了三高的运动处方。项目落成后，加拿大健康管理中心模式已经在全国五个城市落地，带来了广泛的社会和经济效益。
          <br />
        </span>
      </div>
      <div class="image-wrapper_8 flex-row justify-between">
        <img
          class="image_22"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG498bb343080463f2600d85e618c8483b.png'"
        />
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd48b0434ad8fe4ac4f3c3c0aa1775e51.png'"
        />
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGfb6d2a5cb843b49bc09c0976f1d00741.png'"
        />
      </div>
      <div class="box_19 flex-row">
        <div class="box_20 flex-col"></div>
        <div class="box_21 flex-col"></div>
        <div class="box_22 flex-col"></div>
        <div class="box_23 flex-col"></div>
        <img
          class="thumbnail_11"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_12"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_13"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_29">在健康企业中的应用案例</span>
      </div>
      <div class="text-wrapper_17 flex-row">
        <span class="text_30">深圳蛇口招商健康美伦门诊部体医融合专病中心</span>
      </div>
      <div class="text-wrapper_18 flex-row">
        <span class="paragraph_10">
          &nbsp;&nbsp;&nbsp;&nbsp;招商美伦健康作为一个健康管理机构，现在正处于由体检中心向全生命周期健康管理业务转型的关键阶段。2020年，力求打造专业化的健康管理中心，成立了数字化运动康复中心，为各企业或客户带来更加专业的全方位全生命周期的健康管理服务
          <br />
        </span>
      </div>
      <div class="image-wrapper_9 flex-row justify-between">
        <img
          class="image_25"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGfa9a29f6a747e30f045d69f1579069a7.png'"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGb3defcb4fbe2fe0c55fc77f887f1c100.png'"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG6752a4357d5f4c99a60d34d680832eda.png'"
        />
        <img
          class="image_28"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGc88f1761fb9a72ff9c0ed67322fbad6c.png'"
        />
        <img
          class="image_29"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG80dcac3cb3ee3e02ff64ced660b2c8cb.png'"
        />
        <img
          class="image_30"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG8962d3126bf770f6ffec6c6180898def.png'"
        />
      </div>
      <div class="text-wrapper_19 flex-row"><span class="text_31">深圳南山区华润置地企业健康管理中心</span></div>
      <div class="text-wrapper_20 flex-row">
        <span class="paragraph_11">
          &nbsp;&nbsp;&nbsp;&nbsp;以企业职场运动评估干预方案为核心载体共同建立具备专业医学知识框架、符合新一代信息技术要求、满足用户切实需求的企业职场健康管理和风险预警的企业职场运动康复专业内容和领先软件硬件平台。
          <br />
        </span>
      </div>
      <div class="image-wrapper_10 flex-row justify-between">
        <img
          class="image_31"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG43fe892a158a88b0aec9baaee199429a.png'"
        />
        <img
          class="image_32"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG34fe5584bea004bd8e43ee7befc3d808.png'"
        />
      </div>
      <div class="box_24 flex-row">
        <div class="section_1 flex-col"></div>
        <div class="section_2 flex-col"></div>
        <div class="section_3 flex-col"></div>
        <div class="section_4 flex-col"></div>
        <img
          class="thumbnail_14"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_15"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_16"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_32">在社区中的应用案例</span>
      </div>
      <div class="text-wrapper_21 flex-row"><span class="text_33">北京大兴清源路街道养老社区SMIC</span></div>
      <div class="text-wrapper_22 flex-row">
        <span class="paragraph_12">
          &nbsp;&nbsp;&nbsp;&nbsp;为提高养老服务内容，以智能技术为手段，实现养老机构管理全覆盖，老人服务全覆盖，形成生活照料、文娱社交、健康管理、安全居住一体化的生态养老环境，2020年北京市大兴区清源路街道办事处，打造健康管理智能化系统，建立北京大兴清源路街道养老社区SMIC。
          <br />
        </span>
      </div>
      <div class="image-wrapper_11 flex-row justify-between">
        <img
          class="image_33"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG94c82d516b85cff5fbbff3e2995bcfda.png'"
        />
        <img
          class="image_34"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGad637e937bd3110b8adbb133af4ce17e.png'"
        />
        <img
          class="image_35"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG374683916284bce70f3a123ebde9716f.png'"
        />
      </div>
      <div class="text-wrapper_23 flex-row">
        <span class="paragraph_13">
          上海尚体“乐活空间”SMIC
          <br />
        </span>
      </div>
      <div class="text-wrapper_24 flex-row">
        <span class="paragraph_14">
          &nbsp;&nbsp;&nbsp;&nbsp;为了帮助老年人预防和减缓慢性疾病的发生与发展，提高老年人的生活品质。在上海尚体“乐活空间”建立SMIC，打造老年人“举步可就”的“10分钟社区健康生活圈”，解决了老年人去哪儿科学健身的问题和情感孤独问题，提高老年人健康认知和素养，形成社区老年人运动健康促进服务模式，充分发挥全民科学健身在健康促进、慢性病预防和康复等方面的积极作用。
          <br />
        </span>
      </div>
      <div class="image-wrapper_12 flex-row justify-between">
        <img
          class="image_36"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG3e361124f49f34152221d200a0e4b23d.png'"
        />
        <img
          class="image_37"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGb39320c386bb6f8772286f21d395d895.png'"
        />
        <img
          class="image_38"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG3992255f5890a3a8b043a3ee8ebc8b6a.png'"
        />
      </div>
      <div class="box_25 flex-row">
        <div class="section_5 flex-col"></div>
        <div class="section_6 flex-col"></div>
        <div class="section_7 flex-col"></div>
        <div class="section_8 flex-col"></div>
        <img
          class="thumbnail_17"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG08ee2d5e57b66786139b8f5db3c124df.png'"
        />
        <img
          class="thumbnail_18"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGd06c6ef29faf1a57d5ba92308f9d59a9.png'"
        />
        <img
          class="thumbnail_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG381ad4aa090a4e1c3ba6b827ad82b8ab.png'"
        />
        <span class="text_34">典型项目案例展示</span>
      </div>
      <div class="image-wrapper_13 flex-row">
        <img
          class="image_39"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png'"
        />
        <img
          class="image_40"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG81b2d6d9eb5e06b85cd8af3f28f98fb9.png'"
        />
        <img
          class="image_41"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG5159410fc10ca594826b53eb6bbc51dc.png'"
        />
        <img
          class="image_42"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGc0189645430acca8d357caeabdb4f886.png'"
        />
        <img
          class="image_43"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGb19b3156911d708d7021a7e799ab7148.png'"
        />
        <img
          class="image_44"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGe40066d95348fc239dd2466cc6f106e8.png'"
        />
        <img
          class="image_45"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG251a106a920e59378ceee9ded7ea2c9d.png'"
        />
        <img
          class="image_46"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png'"
        />
      </div>
      <div class="text-wrapper_25 flex-row">
        <span class="text_35">深圳招商健康</span>
        <span class="text_36">北京中日友好医院</span>
        <span class="text_37">北京老年医院</span>
        <span class="paragraph_15">
          北京大兴清源路街道
          <br />
          养老社区SMIC
        </span>
        <span class="text_38">北京聚陆医疗</span>
        <span class="paragraph_16">
          北京顺义“妙健康”金茂怡生园
          <br />
          加拿大健康管理中心
        </span>
      </div>
    </div>
    <div class="box_26 flex-col">
      <div class="image-wrapper_14 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png'"
        />
        <img
          class="image_47"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/solution/FigmaDDSSlicePNG62502f655eccbcec3e5735ba277fd3ba.png'"
        />
      </div>
<footerMask/>
    </div>
  </div>
</template>
<script>
import headerMask from "../../components/header";
import footerMask from "../../components/footer";
export default {
  
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight < 1200){
      this.$router.push({path: '/solution_h5'})
    }
  
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />